import { formatMoney, shapes } from '../../Helpers/WindowHelpers';
import ConfiguratorValue from '../../Interfaces/ConfiguratorValue';
import OptionInterface from "../../Interfaces/OptionInterface";

interface ListInterface {
    items: OptionInterface[],
    context: any,
    classes?: string,
    hidePrice?: boolean,
    excludedTitles?: string[],
}

const FormikValueList = ({ items, context, hidePrice, classes, excludedTitles }: ListInterface) => {
    const getCoverVariantInfo = (index: number) => {
        const coverInput = document.querySelector('input.configurator_variant:checked') as HTMLInputElement;
        if (!coverInput) return null;
        return <ListItem
            key={index}
            value={coverInput.getAttribute('data-configurator-title')}
            price={hidePrice ? null : coverInput.getAttribute('data-configurator-variant-price')} />
    }

    return (
        <div className={`${classes || ''}`}>
            <ul>
                {items.map((option, index) => {
                    const field = option.value;
                    const name = option.text;
                    if (field == 'cover') return getCoverVariantInfo(index);
                    const dimensionField = field.includes('dimension_') || field == 'custom_tiedown_distance';
                    const value = (field == 'shape') ? shapes.find((shape) => shape.shape_id == context.values[field])?.name : context.values[field];
                    const excludeField = (excludedTitles ?? []).includes(field);
                    if (typeof value === 'number' && (value && value > 0)) return <ListItem field={excludeField ? null : field} name={name} key={index} value={value} postscript={dimensionField ? '"' : ''}/>
                    if (typeof value === 'string' && (value)) return <ListItem field={excludeField ? null : field} key={index} name={name} value={value} postscript={dimensionField ? '"' : ''} />
                    if (typeof value === 'object' && (value && value.value)) {
                        if(dimensionField && parseFloat(value.value) <= 0) return null;
                        return <ListItem field={excludeField ? null : field} name={name} key={index} value={value.value} price={hidePrice ? null : value.price} postscript={dimensionField ? '"' : ''} />
                    }
                    if (!Array.isArray(context.values.variants)) return null;
                    const arrayItems = context.values.variants.filter((item: ConfiguratorValue) => item.field == field);
                    if (arrayItems.length == 0) return null;
                    return arrayItems.map((item: ConfiguratorValue, subIndex: number) => (<ListItem key={`${index}-${subIndex}`} value={item.value} price={hidePrice ? null : item.price} />))
                })}
            </ul>
        </div>)
}

interface ListItemInterface {
    field?: string,
    name?: string,
    value: string | number,
    price?: string,
    postscript?: string,
    hideField?: boolean
}

const ListItem = ({ field, value, price, postscript, name }: ListItemInterface) => (
    <li><span>{field && `${name}:`} {value}{postscript}</span>{parseInt(price) > 0 && <strong className="float-right">+{formatMoney(price)}</strong>}</li>
);

export default FormikValueList